(function(){

    /*
    * Cambio colore logo sotto slider quando entra in scena
    * */
    document.addEventListener('DOMContentLoaded', () => {
        const header = document.querySelector('#header');      // menu sotto slider
        const logoImg = header?.querySelector('img');

        if (!header || !logoImg) return;

        const WHITE = '-white.svg';

        const toColor = () => {
            const src = logoImg.getAttribute('src') || '';
            if (src.includes(WHITE)) logoImg.setAttribute('src', src.replace(WHITE, '.svg'));
        };

        // Trigger “quando il menu sotto entra davvero in scena”
        const io = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) toColor();
            //else toWhite(); // se non ti serve tornare al white, puoi rimuoverlo
        }, { threshold: 0.01 });

        io.observe(header);
    });



    /*
    * Inizializzazione Swiper.js
    * */
    var swiper = new Swiper(".homeSwiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",
        loop: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    var swiper = new Swiper(".newsSwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "767": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            "992": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            "1200": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
        },
    });

    var swiper = new Swiper(".teamSwiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    var swiper = new Swiper(".aboutSwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "767": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            "992": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            "1200": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
        },
    });

    var swiper = new Swiper(".awardsSwiper", {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 50,
            },
            "992": {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 80,
            },
            "1200": {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 80,
            },
        },
    });



    /*
    * Ottimizzazione per la visualizzazione in "Sticky" delle sezioni interne
    * */
    const el = document.getElementById('activities');
    if (!el) return;

    let raf = 0;

    const getViewportH = () => {
        // migliore su mobile (Safari/iOS con barra indirizzi variabile)
        return (window.visualViewport && window.visualViewport.height) ? window.visualViewport.height : window.innerHeight;
    };

    const update = () => {
        const vh = Math.floor(getViewportH());
        const h  = Math.ceil(el.offsetHeight);

        // se h <= vh => top=0 (comportamento desktop)
        // se h > vh  => top negativo: blocca quando il bottom tocca il bottom del viewport
        const top = Math.min(0, vh - h);

        el.style.setProperty('--activities-sticky-top', `${top}px`);
    };

    const schedule = () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
    };

    // prima misura
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', schedule, { passive: true });
    } else {
        schedule();
    }

    // su resize/orientation change
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });

    // su mobile: viewport dinamico
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', schedule, { passive: true });
    }

    // dopo load (immagini/font possono cambiare altezza)
    window.addEventListener('load', schedule, { passive: true });



    /*
    * Animazione numeri: cambia da 0 a target con animazione in-view
    * */
    document.addEventListener('DOMContentLoaded', () => {
        // Selettore della sezione: cambia con il tuo ID/classe reale
        const section = document.querySelector('#numbers');
        if (!section) return;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const els = section.querySelectorAll('.box-number .number');
        if (!els.length) return;

        // Estrae prefisso, numero e suffisso da stringhe tipo: "+50", "83%", "€1.2M"
        const parse = (raw) => {
            const s = String(raw).trim();

            // prefix = tutto ciò che viene prima del numero
            // number  = parte numerica (con . o , per decimali)
            // suffix = tutto ciò che viene dopo
            const m = s.match(/^([^0-9\-]*)(-?\d+(?:[.,]\d+)?)([^0-9]*)$/);
            if (!m) return null;

            const prefix = m[1] || '';
            const numStr = m[2];
            const suffix = m[3] || '';

            const decimals = (numStr.includes('.') || numStr.includes(','))
                ? (numStr.split(/[.,]/)[1] || '').length
                : 0;

            const target = parseFloat(numStr.replace(',', '.'));
            if (Number.isNaN(target)) return null;

            return { prefix, suffix, target, decimals };
        };

        const formatValue = (value, decimals, isFinal = false) => {
            if (decimals > 0) return value.toFixed(decimals);
            // durante l’animazione arrotondo per evitare “scatti” decimali sugli interi
            return (isFinal ? Math.round(value) : Math.round(value)).toString();
        };

        const animate = (el, meta) => {
            if (el.dataset.animated === '1') return;
            el.dataset.animated = '1';

            const duration = parseInt(el.dataset.duration || '2000', 10); // ms
            const start = 0;
            const { prefix, suffix, target, decimals } = meta;

            const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

            const t0 = performance.now();

            const tick = (now) => {
                const p = Math.min(1, (now - t0) / duration);
                const eased = easeOutCubic(p);
                const current = start + (target - start) * eased;

                el.textContent = `${prefix}${formatValue(current, decimals)}${suffix}`;

                if (p < 1) {
                    requestAnimationFrame(tick);
                } else {
                    // assicura valore finale perfetto
                    el.textContent = `${prefix}${formatValue(target, decimals, true)}${suffix}`;
                }
            };

            requestAnimationFrame(tick);
        };

        // Pre-setup: salva meta e porta a 0 (ma mantenendo + / %)
        const metas = [];
        els.forEach((el) => {
            const meta = parse(el.textContent);
            if (!meta) return;

            metas.push([el, meta]);

            if (prefersReducedMotion) {
                // niente animazione: mostra subito il valore finale
                el.textContent = `${meta.prefix}${formatValue(meta.target, meta.decimals, true)}${meta.suffix}`;
            } else {
                el.textContent = `${meta.prefix}0${meta.suffix}`;
            }
        });

        if (prefersReducedMotion || !metas.length) return;

        // Trigger on enter viewport (una sola volta)
        const io = new IntersectionObserver((entries, obs) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                metas.forEach(([el, meta]) => animate(el, meta));
                obs.unobserve(entry.target);
            });
        }, { threshold: 0.95 });

        io.observe(section);
    });



    const videos = document.querySelectorAll('video[data-lazy-bgvideo]');
    if (!videos.length) return;

    const prefersReducedMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const saveData = navigator.connection && navigator.connection.saveData;

    // Rispetta utenti che preferiscono meno animazioni o risparmio dati
    if (prefersReducedMotion || saveData) {
        videos.forEach(v => {
            v.removeAttribute('autoplay');
            v.pause();
        });
        return;
    }

    function hydrate(video) {
        if (video.dataset.hydrated) return;

        const sources = video.querySelectorAll('source[data-src]');
        sources.forEach(s => {
            s.src = s.dataset.src;
            s.removeAttribute('data-src');
        });

        video.load();
        video.dataset.hydrated = "1";
    }

    async function safePlay(video) {
        try { await video.play(); } catch(e) {}
    }

    if (!('IntersectionObserver' in window)) {
        videos.forEach(v => { hydrate(v); safePlay(v); });
        return;
    }

    const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;

            if (entry.isIntersecting) {
                hydrate(video);
                safePlay(video);
            } else {
                video.pause();
            }
        });
    }, { rootMargin: '200px 0px', threshold: 0.01 });

    videos.forEach(v => io.observe(v));



    document.addEventListener('click', function(e){
        const btn = e.target.closest('.yt-facade__btn');
        if(!btn) return;

        const wrap = btn.closest('.yt-facade');
        const id = wrap && wrap.dataset.ytid;
        if(!id) return;

        // Parametri supportati: controls, rel, iv_load_policy, playsinline, autoplay, fs, ecc.
        // (Alcuni vecchi parametri tipo showinfo e modestbranding sono deprecati/non affidabili)
        const src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(id) + "?autoplay=1&playsinline=1&rel=0&iv_load_policy=3&controls=1";

        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', src);
        iframe.setAttribute('title', 'YouTube video player');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.width = "100%";
        iframe.style.height = "100%";

        // Importante: niente overlay sopra al player una volta caricato (policy)
        wrap.innerHTML = "";
        wrap.appendChild(iframe);
    });

})();
